import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useDependencies } from '@servicetitan/react-ioc';
import { ServiceFinanceStore } from '../../../stores/service-finance.store';
import { FinancingPlan } from './financing-plan';
import { LoanInformation } from './application-information-page/loan-information';
import * as Styles from './plan-selection.less';

export const PlanSelectionPage: React.FC = observer(() => {
    const [store] = useDependencies(ServiceFinanceStore);
    useEffect(() => {
        store.getSelectedProducts();
    }, []);
    return (
        <div className={Styles.container}>
            {
                /* TODO: Show this once we figure out 1) How to show the image. 2) What "Learn more..." is supposed to lead to */
                false && (
                    <div className={Styles.logo}>
                        Financing provided by
                        <br />
                        <img src="assets/images/servicefinance-logo.png" />
                        <span className={Styles.learnMore}>Learn more ...</span>
                    </div>
                )
            }
            <LoanInformation
                loan={store.applicationForm!.$.Loan}
                state={store.applicationForm!.$.PrimaryApplicant.$.HomeAddress.$.State}
                products={store.selectedProducts}
                states={store.getStates()}
                showAllPlans={store.showAllPlans}
                validate={store.validateField}
                isLoanAmountValid={store.isLoanAmountValid}
                plans={store.selectedPlans}
                isLoadingPlans={store.isLoadingPlans}
            />
            {store.selectedPlans && store.selectedPlans.length > 0 && (
                <React.Fragment>
                    <div className={Styles.title}>Please select a plan</div>
                    <div className={Styles.plansContainer}>
                        {store.selectedPlans.map((plan) => (
                            <FinancingPlan
                                plan={plan}
                                isSelected={
                                    store.selectedPlan
                                        ? store.selectedPlan.planNumber === plan.planNumber
                                        : false
                                }
                                loanAmount={store.desiredAmount}
                                selectPlan={store.selectPlan}
                                unSelectPlan={store.unSelectPlan}
                            />
                        ))}
                    </div>
                </React.Fragment>
            )}
        </div>
    );
});
